<span
  class="checkbox"
  [class.checkbox--error]="isErrorShown()"
  [class.checkbox--disabled]="disabled()"
>
  <input
    #checkboxElement
    [id]="id"
    [checked]="checked()"
    [disabled]="disabled()"
    (change)="onChange(checkboxElement)"
    class="checkbox__input"
    type="checkbox"
    hidden
  />

  <label [for]="id" class="checkbox__label">
    <span class="checkbox__mark" data-testid="checkbox-field-mark">
      <fr8bot-ui-icon [name]="'checkmark'" [size]="16" class="checkbox__mark-icon" />
    </span>
    <span class="checkbox__icon empty-hidden">
      <ng-content select="[checkbox-icon]" />
    </span>
    <span class="empty-hidden">
      <ng-content />
      @if (required()) {
        *
      }
    </span>
  </label>
</span>
